// @flow
import React from "react"
import withConnect from "hoc/withConnect"
import { type HOC, withHandlers, compose } from "recompose"
import { UpsellWrapper, Content, TopContent } from "./styled"
import {
  reservationPricingQuery,
} from "data/reservations/graphql/queries"
import withQuery from "hoc/withQuery"
import { openModal } from "data/modals/actions"
import type { Plan } from "data/plans/types"
import { formatMoney } from "data/units/money/formatters"
import type { ReservationPricingQueryInput } from "data/reservations/graphql/queries"
import ArrowIcon from "assets/icons/ArrowIcon"
import { Text } from "componentsStyled/Typography/Texts"
import SubscribePlan from "modals/SubscribePlan"

/**
 * Call to action for user to upgrade their subscription plan by presenting them with
 * the simulated booking price for that plan
 */
const SubscriptionUpsell = ({
  data,
  input,
  subscriptionPlan,
  handleClick,
}) => (
  <UpsellWrapper onClick={handleClick}>
    <Content>
      <Text uppercase bold black bigOnAllDisplays>
        Continue with {subscriptionPlan.title} and save
      </Text>
      <TopContent>
        {subscriptionPlan.upsellConditions && subscriptionPlan.upsellConditions.map(condition =>
          <Text small>
            > {condition}
          </Text>
          )
        }
      </TopContent>
      <Text black small>
        Your booking = {formatMoney(data.fullPrice, true, data.currency)} {data.currency}
      </Text>
      <Text black small>
        With {subscriptionPlan.title} = {formatMoney(data.totalPrice, true, data.currency)} {data.currency}
      </Text>
      <Text black bold small>
        Savings = {formatMoney(data.fullPrice - data.totalPrice, true, data.currency)} {data.currency}
      </Text>
    </Content>
    <ArrowIcon rotation="right" />
  </UpsellWrapper>
)

const mapDispatchToProps = {
  openModal,
}

type Outter = {|
  input: ReservationPricingQueryInput,
  subscriptionPlan: Plan,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withQuery(reservationPricingQuery, {
    variables: props => ({
        input: {
          ...props.input,
          subscriptionSlug: props.subscriptionPlan.slug,
        },
      }),
    noLoader: true,
  }),
  withHandlers({
    handleClick: props => () =>
      props.openModal(SubscribePlan, {
        plan: props.subscriptionPlan,
        details: true,
        fromCheckout: true,
      })
  }),
)

export default enhancer(SubscriptionUpsell)



// WEBPACK FOOTER //
// ./src/components/SubscriptionUpsell/index.js